import config, { FEATURE_FLAGS } from '@/libs/utils/config';

export const redirectIfPublicPaymentFeatureFlagDisabled = (to, from, next) => {
  if (config.features.has(FEATURE_FLAGS.PUBLIC_PAYMENT_LINK)) {
    next();
  } else {
    window.location.href = '/accounts/login/';
  }
};
